import { BASE_URL } from "config";
import { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
import ProductsTableData from "./data/productsTableData";
import TextField from "@mui/material/TextField";
import { useMaterialUIController, setDirection } from "context";
import MDButton from "components/MDButton";
import AddProductModal from "components/AddProductModal";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import RowsPerPageSelector from "components/RowsPerPageSelector";
import { set } from "date-fns";

function Products() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [controller, dispatch] = useMaterialUIController();
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null); // Add current user state
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1); // New state for page number
  const [totalPages, setTotalPages] = useState(1); // New state for total pages

  // Modify modal opening logic
  const handleEditClick = (user) => {
    console.log("the user is : ", user);
    setCurrentUser(user);
    setModalOpen(true);
  };
  useEffect(() => {
    setDirection(dispatch, "rtl");
    fetchUsers(pageNumber);
    return () => setDirection(dispatch, "ltr");
  }, [pageNumber, dispatch]);
  // get store products
  const fetchUsers = async (pageNumber) => {
    setLoading(true);
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(`${BASE_URL}/manager/products?page=${pageNumber}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setUsers(data.data || []);
      setRowsPerPage(data.per_page || 10);
      setTotalPages(data.last_page || 1); // Update total pages
      console.log(data.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  const { columns, rows } = ProductsTableData(users, handleEditClick, fetchUsers);

  const filteredRows = rows.filter((row) =>
    row.name.props.name.toLowerCase().includes(search.toLowerCase())
  );
  const paginatedRows = filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  useEffect(() => {
    setPage(0); // تصفير الصفحة عند تغيير البحث
  }, [search, rowsPerPage]);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <AddProductModal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setCurrentUser(null);
        }}
        onUserAdded={fetchUsers}
        initialData={currentUser} // Pass current user data
      />

      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "linear-gradient(90deg, #ca9937, #e0b15a)",
              boxShadow: 3,
            }}
          >
            <MDTypography variant="h6" color="white">
              قائمة المنتجات
            </MDTypography>

            <MDButton
              variant="contained"
              color="white"
              startIcon={<AddIcon />}
              sx={{ color: "white" }}
              onClick={() => setModalOpen(true)}
            >
              منتج جديد
            </MDButton>
          </MDBox>

          {/* Loading animation like orders page */}
          {loading ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="300px"
              py={6}
            >
              <CircularProgress size={60} sx={{ color: "#ca9937" }} />
            </Box>
          ) : (
            <MDBox pt={3} px={2}>
              <TextField
                fullWidth
                label="بحث بالاسم "
                variant="outlined"
                size="small"
                sx={{ mb: 3 }}
                onChange={(e) => setSearch(e.target.value)}
              />
              <MDBox mb={2} display="flex">
                <RowsPerPageSelector value={rowsPerPage} onChange={setRowsPerPage} />
              </MDBox>
              <DataTable
                table={{ columns, rows: paginatedRows }}
                isSorted={false}
                showTotalEntries={true}
                noEndBorder
                pagination={{ variant: "gradient", color: "info" }}
                sx={{
                  "& .MuiTable-root": { minWidth: 1000 },
                  "& .MuiTableCell-root": {
                    py: 1.5,
                    borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                  },
                  "& .MuiTableHead-root": {
                    backgroundColor: (theme) => theme.palette.grey[100],
                  },
                }}
              />
            </MDBox>
          )}
          <MDBox display="flex" justifyContent="center" mt={4} pb={4} px={2}>
            <MDButton
              onClick={() => {
                if (pageNumber > 1) {
                  setPageNumber(pageNumber - 1);
                }
              }}
              disabled={pageNumber === 1}
              sx={{
                background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                color: "white",
                borderRadius: "50%",
                width: "50px",
                height: "50px",
                minWidth: "50px",
                mx: 1,
                "&:hover": {
                  background: "linear-gradient(90deg, #b6842f, #d39d45)",
                },
              }}
            >
              <ArrowBackIcon />
            </MDButton>

            <MDTypography
              variant="button"
              color="text"
              sx={{
                display: "flex",
                alignItems: "center",
                mx: 3,
                fontWeight: "bold",
              }}
            >
              الصفحة {pageNumber}
            </MDTypography>

            <MDButton
              onClick={() => {
                if (pageNumber < totalPages) {
                  setPageNumber(pageNumber + 1);
                }
              }}
              disabled={pageNumber === totalPages}
              sx={{
                background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                color: "white",
                borderRadius: "50%",
                width: "50px",
                height: "50px",
                minWidth: "50px",
                mx: 1,
                "&:hover": {
                  background: "linear-gradient(90deg, #b6842f, #d39d45)",
                },
              }}
            >
              <ArrowForwardIcon />
            </MDButton>
          </MDBox>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default Products;
